import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export const friendRequest = {
  data() {
    return {
      waitingFriendRequest: false,
    };
  },
  methods: {
    ...mapActions([
      'friendRequestAccount',
      'friendRemoveAccount',
      'friendCancelAccount',
      'friendAcceptAccount',
      'errorNotify',
    ]),
    ...mapMutations(['updateCounterKey']),
    friendRequestProfileAction({
      account = null,
      socials = null,
      accountType = account ? account._type : '',
      accountId = account ? account._id : '',
      isDeclineRequest = false,
    }) {
      // setDefaults from current/account
      if (!this.$lodash.isEmpty(account)) {
        const socialMetadata = account.socialMetadata || {};

        socials = {
          isFollow: socialMetadata.is_follow,
          isFriend: socialMetadata.is_friend,
          isFriendRequested: socialMetadata.is_friend_requested,
          isFriendRequestedBy: socialMetadata.is_friend_requested_by,
        };
      }

      if (this.$lodash.isEmpty(socials)) {
        return Promise.reject();
      }

      this.waitingFriendRequest = true;
      const { isFriend, isFriendRequested, isFriendRequestedBy } = socials;
      const wantToAdd = !isFriend && !isFriendRequested && !isFriendRequestedBy;
      const wantToRemove = isFriend;
      const wantToCancel = !isFriend && isFriendRequested;
      const wantToAccept =
        !isFriend && isFriendRequestedBy && !isDeclineRequest;
      const action = wantToAdd
        ? 'friendRequestAccount'
        : wantToRemove
        ? 'friendRemoveAccount'
        : wantToAccept
        ? 'friendAcceptAccount'
        : 'friendCancelAccount';

      return this[action]({ accountType, accountId })
        .then(() => {
          if (wantToAdd) {
            socials.isFriendRequested = true;
            socials.isFriend = false;
          }
          if (wantToAccept) {
            socials.isFriendRequested = false;
            socials.isFriend = true;
          }
          if (wantToCancel || wantToRemove) {
            socials.isFriendRequested = false;
            socials.isFriend = false;
          }
          if (socials.isFriendRequested) {
            socials.isFollow = true;
          }
          socials.isFriendRequestedBy = false;
          if (account) {
            account.update(
              {
                socialMetadata: {
                  is_follow: socials.isFollow,
                  is_friend: socials.isFriend,
                  is_friend_requested: socials.isFriendRequested,
                  is_friend_requested_by: socials.isFriendRequestedBy,
                },
              },
              true
            );
          }

          return {
            ...socials,
            addedToFriend: !isFriend && socials.isFriend,
            removedToFriend: isFriend && !socials.isFriend,
          };
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.waitingFriendRequest = false;
          this.updateCounterKey();
        });
    },
    friendAcceptRequestProfileAction({
      account = null,
      socials = null,
      accountType = account ? account._type : '',
      accountId = account ? account._id : '',
    }) {
      // setDefaults from current/account
      if (!this.$lodash.isEmpty(account)) {
        const socialMetadata = account.socialMetadata || {};

        socials = {
          isFollow: socialMetadata.is_follow,
          isFriend: socialMetadata.is_friend,
          isFriendRequested: socialMetadata.is_friend_requested,
          isFriendRequestedBy: socialMetadata.is_friend_requested_by,
        };
      }

      if (this.$lodash.isEmpty(socials)) {
        return Promise.reject();
      }
      this.waitingFriendRequest = true;

      return this.friendAcceptAccount({ accountType, accountId })
        .then(() => {
          socials.isFriendRequested = false;
          socials.isFriend = true;
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.waitingFriendRequest = false;
          this.updateCounterKey();
        });
    },
    friendRequestProfileText({
      account = null,
      socials = null,
      isDeclineRequest = false,
    }) {
      // setDefaults from current/account
      if (!this.$lodash.isEmpty(account)) {
        const socialMetadata = account.socialMetadata || {};

        socials = {
          follow: socialMetadata.is_follow,
          isFriend: socialMetadata.is_friend,
          isFriendRequested: socialMetadata.is_friend_requested,
          isFriendRequestedBy: socialMetadata.is_friend_requested_by,
        };
      }

      if (this.$lodash.isEmpty(socials)) {
        return '';
      }

      return socials.isFriend
        ? this.$t(
            '_web_user-actions_friend-request_remove',
            'Remove from friends'
          )
        : socials.isFriendRequested
        ? this.$t(
            '_web_user-actions_friend-request_cancel',
            'Cancel friend request'
          )
        : isDeclineRequest
        ? this.$t('_web_user_actions_friend-request_decline', 'Decline request')
        : socials.isFriendRequestedBy && !isDeclineRequest
        ? this.$t('_web_user-actions_friend-request_add', 'Confirm request')
        : this.$t('_web_user-actions_friend_add', 'Add to friends');
    },
  },
};
export const clanInvite = {
  data() {
    return {
      waitingClanInvite: false,
      isInvited: false,
      isInvitedList: [],
    };
  },
  computed: {
    ...mapState('my', { myAccount: 'account' }),
    ...mapGetters('my/clans', ['isMemberOfAClan']),
  },
  methods: {
    ...mapActions(['clanInviteAccount', 'clanRemoveAccount']),
    clanInviteProfileAction(accountId, clanId) {
      if (!accountId || !clanId) {
        return Promise.reject();
      }

      this.waitingClanInvite = true;

      if (!this.isMemberOfAClan(clanId)) {
        return Promise.reject(new Error('You have no clan'));
      }
      this[this.isInvited ? 'clanRemoveAccount' : 'clanInviteAccount']({
        accountId,
        clanId,
      })
        .then(() => {
          this.isInvited = !this.isInvited;

          if (this.isInvited) {
            this.isInvitedList = [...this.isInvitedList, accountId];
          } else {
            this.isInvitedList = this.isInvitedList.filter(
              id => id !== accountId
            );
          }

          return this.isInvited;
        })
        .finally(() => {
          this.waitingClanInvite = false;
        });
    },
    clanInviteProfileText(account) {
      if (this.$lodash.isEmpty(account)) {
        return '';
      }

      // fail!
      return this.isInvited
        ? this.$t('_web_user_actions_clan_invite-btn', 'Cancel invite')
        : this.$t('_web_user_actions_team_invite', 'Invite to the team');
    },
  },
};
export const report = {
  data() {
    return {
      waitingReportRequest: false,
    };
  },
  methods: {
    reportProfileAction(/*{ accountType, accountId }*/) {
      // todo not worked #6184
      return null;
    },
    reportProfileText() {
      return this.$t('_web_user_actions_report', 'Report');
    },
  },
};

export default [friendRequest, clanInvite, report];
